import React, { useMemo, useEffect, useState } from "react";
import { MaterialReactTable } from "material-react-table";
import { Button, Divider, Typography } from "antd";
import { request, requestWithImage } from "../../../functions/request";
import Aguarde from "../../../components/aguarde/aguarde";
import { useNavigate } from "react-router-dom";
import { BiRightArrow } from "react-icons/bi";
import {
  AiOutlineSearch,
  AiFillEdit,
  AiFillEye,
  AiOutlinePause,
} from "react-icons/ai";
import ModalDossiePreview from "../../../components/Modal/Dossie/ModalDossiePreview";
import ModalAddDossie from "../../../components/Modal/Dossie/ModalAddDossie";
import { VscCircleLargeFilled } from "react-icons/vsc";
import { MRT_Localization_PT_BR } from "material-react-table/locales/pt-BR";
import { confirmAlert } from "react-confirm-alert";
import { PiTelevisionFill } from "react-icons/pi";
import { toast } from "react-toastify";
import { uniKey, validData } from "../../../functions/functionsUtility";
import { Content } from "antd/es/layout/layout";
import { FaPlus } from "react-icons/fa";

const Dossies = () => {
  const navigate = useNavigate();
  //Modal Preview
  const [previewContent, setPreviewContent] = useState("");
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);

  //Modal Add
  const [isAddOpen, setIsAddOpen] = useState(false);
  const [editOpen, setEditOpen] = useState({});

  const [haveResult, setHaveResult] = useState(false);
  const [tableData, setTableData] = useState([]);
  const confirmStop = (row) => {
    confirmAlert({
      title:
        row.original.dos_ativo === 1
          ? "Você tem certeza que deseja pausar esse dossiê?"
          : "Você tem certeza que deseja ativar esse dossiê?",
      message:
        row.original.dos_ativo === 1
          ? "Todos os seus capítulos sairão do ar e não poderão ser acessados pelos usuários."
          : "Todos os seus capítulos voltarão a ficar disponíveis para os usuários.",
      buttons: [
        {
          label: "Não",
          className: "button-delete",
          onClick: () => {},
        },
        {
          label: "Sim",
          className: "button-save",
          onClick: () => {
            const updatedRow = {
              ...row.original,
              dos_ativo: row.original.dos_ativo === 1 ? 0 : 1,
            };
            changeDossie(updatedRow);
          },
        },
      ],
    });
  };

  const changeDossie = async (row, dos_banner = null, dos_capa = null) => {
    const result = await validData(row, [
      "dos_nome",
    ]);
    if (!result) {
      toast.error("Preencha todos os campos obrigatórios! Campo: Nome");
      return false;
    }

    try {
      const newData = JSON.stringify({ ...row, index: uniKey() });
      const formData = new FormData();
      formData.append("newData", newData);
      if (dos_banner !== null) {
        formData.append("dos_banner", dos_banner);
      }
      if (dos_capa !== null) {
        formData.append("dos_capa", dos_capa);
      }
      const response = await requestWithImage("/dossie/updateDossie", {
        method: "PUT",
        body: formData,
      })
        .then((res) => {
          toast.success("Dossiê Salvo com Sucesso!");
          setIsAddOpen(false);
          setTimeout(() => {
            window.location.reload();
          }, 2000);
        })
        .catch((err) => {
          console.log(err);
          toast.error("Erro ao Salvar Dossiê!");
        });
    } catch (error) {
      console.error("Erro na requisição:", error);
    }
  };

  useEffect(() => {
    const fetchTableData = async () => {
      try {
        const currentPathWithQuery = "/dossie/getAllDossies";
        const response = await request(currentPathWithQuery, {
          method: "GET",
        });
        setTableData(response);
        setHaveResult(true);
      } catch (error) {
        console.error("Erro na requisição:", error);
      }
    };
    fetchTableData();
  }, []);
  //should be memoized or stable
  const columns = useMemo(
    () => [
      {
        accessorKey: "dos_id", //access nested data with dot notation
        header: "Id",
        size: 10,
      },

      {
        accessorKey: "dos_nome", //access nested data with dot notation
        header: "Nome do Dossiê",
        size: 50,
      },
      {
        accessorKey: "dos_capitulos", //normal accessorKey
        header: "Quantidade de Capítulos",
        size: 50,
      },
      {
        accessorKey: "dos_ativo",
        header: "Dossiê Ativo",
        size: 50,
        Cell: ({ cell }) =>
          cell.getValue() === 1 ? (
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <VscCircleLargeFilled
                color="info"
                fontSize="small"
                className="active-icon"
              />
              Ativo
            </div>
          ) : cell.getValue() === 0 ? (
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <VscCircleLargeFilled
                color="info"
                fontSize="small"
                style={{ color: "var( --gray-color)" }}
              />
              Offline
            </div>
          ) : null,
      },
    ],
    []
  );
  const addElement = (el, row) => {};
  const editElement = (el, row) => {
    navigate(
      `/dossies/editar/${row.original.dos_id}` +
        `?nome=${encodeURIComponent(row.original.dos_nome)}`
    );
  };
  const openModal = async (content) => {
    try {
      const currentPathWithQuery = `/dossie_capitulos/getCapitulos?id=${encodeURIComponent(
        content.original.dos_id
      )}`;
      const response = await request(currentPathWithQuery, {
        method: "GET",
      });
      setIsPreviewOpen(true);
      setPreviewContent({
        data: response,
        dos_nome: content.original.dos_nome,
      });
    } catch (error) {
      console.error("Erro na requisição:", error);
    }
  };
  const closeModal = () => {
    setIsPreviewOpen(false);
  };

  return (
    <>
      <ModalDossiePreview
        isPreviewOpen={isPreviewOpen}
        previewContent={previewContent}
        onRequestClose={closeModal}
      />
      <ModalAddDossie
        editOpen={editOpen}
        setEditOpen={setEditOpen}
        isAddOpen={isAddOpen}
        onRequestClose={() => setIsAddOpen(false)}
        changeDossies={changeDossie}
        index={tableData[tableData.length - 1]?.dos_id + 1}
      />
      {haveResult ? (
        tableData.length > 0 ? (
          <MaterialReactTable
            columns={columns}
            data={tableData}
            defaultColumn={{
              minSize: 5, //allow columns to get smaller than default
              maxSize: 100,
              size: 100,
            }}
            enableColumnFilterModes
            enableColumnSorting
            enableRowActions
            localization={MRT_Localization_PT_BR}
            positionActionsColumn="last"
            enableRowVirtualization
            enableFacetedValues
            columnFilterModeOptions={null}
            initialState={{
              showColumnFilters: true,
              pagination: { pageIndex: 0, pageSize: 20 },
            }}
            displayColumnDefOptions={{
              "mrt-row-actions": {
                header: "", // Altere o texto do cabeçalho, se necessário
                size: 100, // Faça a coluna de ações um pouco mais larga
              },
            }}
            renderRowActions={({ row }) => (
              <div
                style={{ display: "flex", gap: "5px", justifyContent: "end" }}
              >
                <Button
                  onClick={(el) => openModal(row)}
                  style={{ display: "flex", alignItems: "center", gap: "5px" }}
                >
                  <AiFillEye />
                  Visualizar
                </Button>
                <Button
                  onClick={(el) => editElement(el.value, row)}
                  style={{ display: "flex", alignItems: "center", gap: "5px" }}
                >
                  <PiTelevisionFill />
                  Capítulos
                </Button>
                <Button
                  onClick={(el) => {
                    setEditOpen(row.original);
                    setIsAddOpen(true);
                  }}
                  style={{ display: "flex", alignItems: "center", gap: "5px" }}
                >
                  <AiFillEdit />
                  Editar
                </Button>
                <Button
                  onClick={(el) => confirmStop(row)}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {row.original.dos_ativo ? (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "5px",
                      }}
                    >
                      <AiOutlinePause /> Pausar
                    </div>
                  ) : (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "5px",
                      }}
                    >
                      <BiRightArrow /> Ativar
                    </div>
                  )}
                </Button>
              </div>
            )}
            renderTopToolbarCustomActions={() => (
              <Content
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 20,
                  padding: 10,
                }}
              >
                <Typography.Title
                  level={4}
                  style={{
                    margin: 0,
                    display: "flex",
                    gap: 5,
                    alignItems: "center",
                  }}
                >
                  Dossiês
                </Typography.Title>
                <Divider type="vertical" />
                <Button
                  type="primary"
                  icon={<FaPlus />}
                  size="large"
                  onClick={(el) => {
                    setEditOpen({});
                    setIsAddOpen(true);
                  }}
                >
                  Adicionar Dossiê
                </Button>
              </Content>
            )}
            muiTableHeadCellFilterTextFieldProps={{
              placeholder: "Filtrar",
            }}
          />
        ) : (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              height: "80%",
            }}
          >
            <h2>Ops! Não encontramos resultados para a busca.</h2>
            <AiOutlineSearch size={48} color="#888" />
            <p>Tente pesquisar novamente com outros termos ou filtros.</p>
          </div>
        )
      ) : (
        <Aguarde />
      )}
    </>
  );
};

export default Dossies;
